import KpiCard from '../../components/admin/KpiCard';
import TimeSeriesChart from '../../components/admin/TimeSeriesChart';
import useAdminData from './useAdminData';
import { fetchOverview, fetchMessagesSeries } from '../../services/adminStatsService';

export default function AdminOverview() {
  const { data, loading, error } = useAdminData(fetchOverview);
  const series = useAdminData(fetchMessagesSeries, 'granularity=day');

  if (loading) return <div className="text-gray-500">Loading…</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!data) return null;

  const { current, previous } = data;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KpiCard label="Messages in" value={current.totalMessagesIn} previous={previous.totalMessagesIn} icon="📥" />
        <KpiCard label="Messages out" value={current.totalMessagesOut} previous={previous.totalMessagesOut} icon="📤" />
        <KpiCard label="New conversations" value={current.newConversations} previous={previous.newConversations} icon="💬" />
        <KpiCard label="Closed conversations" value={current.closedConversations} previous={previous.closedConversations} icon="✅" />
        <KpiCard label="Active conversations" value={current.activeConversations} previous={previous.activeConversations} icon="🟢" />
        <KpiCard label="With lead" value={current.conversationsWithLead} previous={previous.conversationsWithLead} icon="🎯" />
        <KpiCard
          label="Avg first response (min)"
          value={current.avgFirstResponseMin}
          previous={previous.avgFirstResponseMin}
          icon="⏱️"
          invertDelta
        />
        <KpiCard
          label="Failed messages"
          value={current.failedMessages}
          previous={previous.failedMessages}
          icon="⚠️"
          invertDelta
        />
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Messages over time</h3>
        {series.loading ? (
          <div className="text-gray-500 text-sm">Loading series…</div>
        ) : series.error ? (
          <div className="text-red-600 text-sm">{series.error}</div>
        ) : (
          <TimeSeriesChart
            data={series.data?.data || []}
            series={[
              { key: 'inbound', label: 'Inbound' },
              { key: 'outbound', label: 'Outbound' },
              { key: 'failed', label: 'Failed', color: '#DC2626' },
            ]}
          />
        )}
      </div>
    </div>
  );
}
